module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/Medical_Device_Depot-384e30338bd95e486ec55c5ff23e94e9.png";